<template></template>

<script>
    export default {
        data() {
            return {
                classToLookFor: 'navigatable',
                activeClass: 'navigation-selected-active',
                activeElement: null
            }
        },

        mounted() {
            this.selectFirstElement()

            window.addEventListener('keydown', this.checkKey)
        },
        
        destroyed() {
            window.removeEventListener('keydown', this.checkKey)
        },

        methods: {
            selectFirstElement() {
                const elements = this.elements()

                if (!elements.length) {
                    return
                }

                this.select(elements[0])
            },

            select(element) {
                if (this.activeElement !== null) {
                    this.activeElement.classList.remove(this.activeClass)
                }

                this.activeElement = element
                this.activeElement.className += ' ' + this.activeClass
            },

            elements() {
                return document.body.querySelectorAll('.' + this.classToLookFor)
            },

            checkKey(event) {
                const validKeys = [13, 37, 38, 39, 40]

                const keyCode = event.keyCode

                if (validKeys.indexOf(keyCode) === -1) {
                    return
                }

                let direction = null

                const tagName = document.activeElement.tagName.toLowerCase()

                switch(keyCode) {
                    case 13:
                        if (tagName === 'textarea') {
                            return
                        }

                        this.enter()
                        return
                        break

                    case 37:
                        direction = 'left'
                        break

                    case 38:
                        direction = 'up'
                        break

                    case 39:
                        direction = 'right'
                        break

                    case 40:
                        direction = 'down'
                        break
                }

                if (direction === 'up' || direction === 'down' && tagName !== 'textarea') {
                    event.preventDefault()
                }

                if (this.activeElement) {
                    if (tagName === 'input' || tagName === 'textarea') {
                        if (direction === 'left' || direction === 'right') {
                            let position = document.activeElement.selectionStart
                            let characters = document.activeElement.value.length

                            if (
                                (
                                    position !== 0 &&
                                    direction === 'left'
                                ) ||
                                (
                                    position !== characters &&
                                    direction === 'right'
                                )
                            ) {
                                return
                            }
                        }

                        document.activeElement.blur()
                    }
                }

                return this.locateElement(direction)
            },

            locateElement(direction) {
                if (!this.activeElement) {
                    return
                }

                const current = this.position(this.activeElement)

                const filter = Array.prototype.filter

                const potentialElements = filter.call(this.elements(), (element) => {
                    const position = this.position(element)

                    switch (direction) {
                        case 'left':
                            return (position.left < current.left)
                            break

                        case 'up':
                            return (position.top < current.top)
                            break

                        case 'right':
                            return (position.left > current.left)
                            break

                        case 'down':
                            return (position.top > current.top)
                            break
                    }
                })

                let selectedElement = null
                let selectedDistance = 0

                potentialElements.forEach((element) => {
                    const position = this.position(element)

                    let distance = this.distance(element)

                    if (direction === 'left' || direction === 'right') {
                        let diff = Math.abs(current.top - position.top)
                    }

                    if (direction === 'up' || direction === 'down') {
                        let diff = Math.abs(current.left - position.left)
                    }

                    if (distance < 0) {
                        distance = distance * - 1
                    }

                    if (distance > selectedDistance && selectedElement !== null) {
                        return
                    }

                    selectedElement = element
                    selectedDistance = distance
                })

                if (!selectedElement) {
                    return
                }

                this.select(selectedElement)

                if (direction == 'up' || direction == 'down') {
                    this.scrollToElement()
                }
            },

            /**
             * Get distance
             */
            distance(element) {
                if (!this.activeElement) {
                    return 0
                }

                const current = this.position(this.activeElement)

                const position = this.position(element)

                let distance = 0

                distance += Math.abs(current.left - position.left)
                distance += Math.abs(current.top - position.top)

                return distance
            },

            /**
             * Get position
             *
             * @param element
             * @returns {{left: number, top: number}}
             */
            position(element) {
                return {
                    left: element.getBoundingClientRect().left - window.scrollX,
                    top: element.getBoundingClientRect().top - window.scrollY
                }
            },

            enter() {
                if (!this.activeElement) {
                    return
                }

                this.activeElement.click()
            },

            scrollToElement() {
                if (!this.activeElement) {
                    return
                }

                var bodyRect = document.body.getBoundingClientRect(),
                    elemRect = this.activeElement.getBoundingClientRect(),
                    offset   = elemRect.top - bodyRect.top;

                document.body.scrollTop = offset - (window.innerHeight * 0.4)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// KeyNavigation.vue?e899e7fe